<template>
	<snackbar v-model="isActive" v-bind="props" v-on="listeners"/>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {useGlobalSnackbarStore} from "../../store/global-snackbar";

const isActive = ref(false);
const props = ref({});
const listeners = ref({});

const store = useGlobalSnackbarStore();
store.$subscribe((mutation, state) => {
	props.value = state.props;
	listeners.value = state.listeners;
	isActive.value = state.isVisible;
})
</script>